export class DFirmasConteoVista {  

    firmasHechas: number;
    firmasPendientes: number;

    constructor(
        firmasHechas: number,
        firmasPendientes: number
    ){
        this.firmasHechas = firmasHechas;
        this.firmasPendientes = firmasPendientes;
    }
    
}


// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/to/dfirmas-conteo-vista.ts